import { IGizmo, IRootGizmoData, TJsonData } from '../../../types';
import { gnov, snov } from '../../../utils';

interface IParams {
  config: IGizmo;
  data: IRootGizmoData;
}

/**
 * Transforms the root gizmo data to a json object, depending on the root gizmo configuration
 *
 * @param {IGizmo} config root gizmo configuration
 * @param {IRootGizmoData} data root gizmo data
 * @returns
 */
function flowyToJson({ config, data }: IParams): TJsonData {
  let jsonData: TJsonData = {};

  if (config.gizmos && data.j) {
    jsonData = data.j;

    for (const gizmo of config.gizmos) {
      if (gizmo.ops?.json?.path) {
        const path = gizmo.ops.json.path;

        const value = gnov(data, `d.${gizmo.fid}.v`);

        if (value !== undefined) {
          snov(jsonData, path, value);
        }
      }
    }
  }

  return jsonData;
}

export default flowyToJson;
